// ProductiveTimeLineChart.jsx
import React from 'react';
import { LineChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const ProductiveTimeLineChart = ({
  data = [],
  title = 'Tiempo productivo por turno',
  height = '400px',
}) => {
  const chartData = data.map((d) => ({
    group: d.group,          // "Día" / "Noche"
    date: new Date(d.date),  // eje tiempo
    value: d.value_h,        // horas productivas
  }));

  const options = {
    title,
    height,
    theme: 'g100', // ⬅⬅⬅ tema oscuro: textos claros/blancos

    axes: {
      bottom: {
        title: 'Fecha',
        mapsTo: 'date',
        scaleType: 'time',
      },
      left: {
        title: 'Horas productivas',
        mapsTo: 'value',
        scaleType: 'linear',
      },
    },

    curve: 'curveMonotoneX',

    legend: {
      enabled: true,
    },

    // Solo colores de la data (las líneas), lo demás lo controla el theme
    color: {
      scale: {
        Día: '#42BE65',     // verde
        Noche: '#4589FF',   // azul
      },
    },
  };

  return <LineChart data={chartData} options={options} />;
};

export default ProductiveTimeLineChart;